export default function initMenu() {

    const nav = document.querySelector('nav[aria-label="Navigation - Mobile"]');
    if (!nav) return;

    let initialised = false;

    // WP renders the overlay lazily and adds is-menu-open when opened.
    // We wait for that before touching the DOM.
    const observer = new MutationObserver(() => {
        const overlay = nav.querySelector('.wp-block-navigation__responsive-container.is-menu-open');
        if (overlay && !initialised) {
            initialised = true;
            observer.disconnect();
            buildSlider(nav);
        }
    });

    observer.observe(nav, { subtree: true, attributes: true, attributeFilter: ['class'] });

    // Lock/unlock body scroll with menu open state
    const bodyObserver = new MutationObserver(() => {
        const isOpen = !!nav.querySelector('.wp-block-navigation__responsive-container.is-menu-open');
        //document.documentElement.style.overflow = isOpen ? 'hidden' : '';
    });

    bodyObserver.observe(nav, { subtree: true, attributes: true, attributeFilter: ['class'] });
}

function buildSlider(nav) {
    const container = nav.querySelector('.wp-block-navigation__responsive-container-content');
    if (!container) return;

    const rootUl = container.querySelector('ul.wp-block-navigation__container');
    if (!rootUl) return;

    // Disable WP's own submenu toggle buttons so they don't fight us
    nav.querySelectorAll('.wp-block-navigation__submenu-icon').forEach(btn => {
        btn.style.pointerEvents = 'none';
        btn.style.display = 'none';
    });

    // Build slider wrapper
    const slider = document.createElement('div');
    slider.className = 'sm__slider';
    rootUl.parentNode.insertBefore(slider, rootUl);

    // panels array — index matches navigation level
    // Each entry: { panel, ul, parentIndex }
    const panels = [];
    let currentIndex = 0;
    let isAnimating = false;

    function addPanel(ul, parentIndex) {
        const panel = document.createElement('div');
        panel.className = 'sm__panel';
        panel.appendChild(ul);
        slider.appendChild(panel);
        const index = panels.length;
        panels.push({ panel, ul, parentIndex });
        // All panels except root start hidden off-screen
        if (index > 0) {
            panel.style.position = 'absolute';
            panel.style.top = '0';
            panel.style.left = '0';
            panel.style.width = '100%';
            panel.style.transform = 'translateX(100%)';
        }
        return index;
    }

    function goTo(targetIndex) {
        if (isAnimating) return;

        const direction = targetIndex === panels[currentIndex]?.parentIndex ? -1 : 1;

        const incoming = panels[targetIndex].panel;
        const outgoing = panels[currentIndex].panel;

        // Snap incoming off-screen (no transition)
        incoming.style.transition = 'none';
        incoming.style.position = 'absolute';
        incoming.style.top = '0';
        incoming.style.left = '0';
        incoming.style.width = '100%';
        incoming.style.transform = `translateX(${direction * 100}%)`;
        incoming.offsetHeight; // force reflow

        // Measure incoming height before animating
        const fromHeight = slider.offsetHeight;
        const toHeight = incoming.scrollHeight;

        isAnimating = true;

        // Slide outgoing out
        outgoing.style.transition = 'transform 300ms ease-in-out';
        outgoing.style.transform = `translateX(${direction * -100}%)`;

        // Slide incoming in + animate height simultaneously
        incoming.style.transition = 'transform 300ms ease-in-out';
        incoming.style.transform = 'translateX(0%)';

        slider.style.transition = 'height 300ms ease-in-out';
        slider.style.height = fromHeight + 'px';
        slider.offsetHeight; // force reflow so height is painted before transition
        slider.style.height = toHeight + 'px';

        incoming.addEventListener('transitionend', () => {
            outgoing.style.position = 'absolute';
            incoming.style.position = 'relative';
            incoming.style.top = '';
            incoming.style.left = '';
            incoming.style.width = '';
            slider.style.transition = '';
            slider.style.height = '';
            isAnimating = false;
        }, { once: true });

        currentIndex = targetIndex;
    }

    // Add root as panel 0
    addPanel(rootUl, null);

    // Recursively process all li.has-child — pull each submenu ul into its own panel
    function processSubmenus(ul, parentPanelIndex) {
        ul.querySelectorAll(':scope > li.has-child').forEach(li => {
            const anchor = li.querySelector(':scope > a');
            const submenu = li.querySelector(':scope > ul');
            if (!anchor || !submenu) return;

            const label = li.querySelector('.wp-block-navigation-item__label')?.textContent.trim()
                ?? anchor.textContent.trim();

            // Inject back link at top of this submenu
            if (!submenu.querySelector('.sm__backlink')) {
                const backLi = document.createElement('li');
                backLi.className = 'sm__backlink-item';
                const backA = document.createElement('a');
                backA.href = '#';
                backA.className = 'sm__backlink';
                backA.innerHTML = `<svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.34072 7.15869L8.82905 1.67036L7.15869 -3.12916e-07L3.12916e-07 7.15869L7.15869 14.3174L8.82905 12.647L3.34072 7.15869Z" fill="white"/></svg> ${label}`;
                backLi.appendChild(backA);
                submenu.insertBefore(backLi, submenu.firstChild);
            }

            // Pull submenu out of li into its own panel
            const panelIndex = addPanel(submenu, parentPanelIndex);

            // Recurse into this submenu before attaching click (so nested panels exist)
            processSubmenus(submenu, panelIndex);

            // Click on the li (captures taps on anchor text and the arrow icon area)
            li.addEventListener('click', e => {
                // Ignore clicks on back links or real (non-#) links
                if (e.target.closest('.sm__backlink')) return;
                const clickedAnchor = e.target.closest('a');
                if (clickedAnchor && clickedAnchor.getAttribute('href') !== '#') return;

                e.preventDefault();
                e.stopImmediatePropagation();
                goTo(panelIndex);
            }, true);
        });
    }

    processSubmenus(rootUl, 0);

    // Set initial explicit height so the first transition has a from-value
    slider.style.height = panels[0].panel.scrollHeight + 'px';

    // Back navigation — delegated on slider
    slider.addEventListener('click', e => {
        if (!e.target.closest('.sm__backlink')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        const parentIndex = panels[currentIndex]?.parentIndex;
        if (parentIndex !== null && parentIndex !== undefined) goTo(parentIndex);
    }, true);
}

